import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AutoComplete } from 'material-ui';

import { updateCargoOrder } from 'actions/cargoes/orders';
import api from 'services';
import _ from 'lodash';
import { useRefState } from 'helpers/react.utils';
import { calculateIsIfchorBroker } from 'helpers/realCompanies';

const accountsConfig = {
    text: 'name', 
    value: '_id',
};

function loadCompanies(search, withRealCompanies) {
    if (search.length < 2) {
        return [];
    }
    return api.findCompany(search, withRealCompanies).then(response => response.data.data).catch((err) => {
        console.error(err);
        return null;
    });
}

function AccountName({
    updateCargoOrder, cargoOrder, numberOrderTable, context, 
}) {
    const [accounts, setAccounts] = useState([]);
    const [search, setSearch, searchRef] = useRefState('');

    const onChangeAutoCompleteAccount = async (e) => {
        setSearch(e);

        const newCargoOrder = _.cloneDeep(cargoOrder);
        newCargoOrder.account = {
            _id: undefined,
            name: e,
        };
        updateCargoOrder(numberOrderTable, newCargoOrder);

        const withRealCompanies = calculateIsIfchorBroker(context.userId.email);

        const companies = await loadCompanies(e, withRealCompanies);

        if (searchRef.current !== e) {
            return;
        }

        setAccounts(companies);
    };

    const onChooseAutoCompleteAccount = (e) => {
        const newCargoOrder = _.cloneDeep(cargoOrder);
        newCargoOrder.account = e;
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };
    return (
        <div className='row'>
            <div className='column-left'>
                Account name:
            </div>
            <div className='column-right'>
                <AutoComplete
                    name='accountNameCargo'
                    floatingLabelText='Account Name'
                    textFieldStyle={{ fontSize: '13px' }}
                    hintText='Account'
                    searchText={search || (cargoOrder.account && cargoOrder.account.name) || ''}
                    dataSource={accounts}
                    onUpdateInput={onChangeAutoCompleteAccount}
                    onNewRequest={onChooseAutoCompleteAccount}
                    dataSourceConfig={accountsConfig}
                    filter={AutoComplete.noFilter}
                    listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                    menuStyle={{ width: 'auto' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    fullWidth
                />
            </div>
            <hr />
        </div>
    );
}

export default connect(
    (state, ownProps) => ({
        context: state.letter.context,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
    }),
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(AccountName);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/AccountName.jsx